export default __webpack_public_path__ + "static/media/480_dummy2016-allgemeinarzt01-de.2afdbd12.png";